import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/betroyale/images/footer/logoFooter.png';

export default function index() {
  return (
    <Image src={footerLogo} minW="222px" minH="50px" ml={['0', null, '4']} />
  );
}
